// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalCreateQualiphyProcedure_root__1ZMOO","footer":"ModalCreateQualiphyProcedure_footer__2mNVf","additionData":"ModalCreateQualiphyProcedure_additionData__7z41n"};